export const colors = {
  "chakra-body-text": {
    "_light": "gray.600",
    "_dark": "whiteAlpha.600"
  },
  "chakra-body-bg": {
    "_light": "white",
    "_dark": "gray.950"
  },
  "chakra-border-color": {
    "_light": "grayAlpha.200",
    "_dark": "whiteAlpha.200"
  },
  "chakra-subtle-bg": {
    "_light": "gray.25",
    "_dark": "black"
  },
  "chakra-placeholder-color": {
    "_light": "gray.400",
    "_dark": "whiteAlpha.400"
  },
  "border-default": {
    "_light": "grayAlpha.200",
    "_dark": "whiteAlpha.200"
  },
  "border-subdued": {
    "_light": "blackAlpha.100",
    "_dark": "whiteAlpha.100"
  },
  "border-muted": {
    "_light": "neutral.300",
    "_dark": "whiteAlpha.300"
  },
  "border-input": {
    "_light": "grayAlpha.300",
    "_dark": "whiteAlpha.300"
  },
  "border-emphasis": {
    "_light": "neutral.500",
    "_dark": "neutral.500"
  },
  "border-elevated": {
    "_light": "blackAlpha.50",
    "_dark": "whiteAlpha.100"
  },
  "border-invert": {
    "_light": "whiteAlpha.200",
    "_dark": "blackAlpha.200"
  },
  "border-focus": {
    "_light": "blue.500",
    "_dark": "blue.400"
  },
  "border-focus-secondary": {
    "_light": "blue.50",
    "_dark": "blue.900"
  },
  "border-brand": {
    "_light": "brand.300",
    "_dark": "brand.700"
  },
  "border-neutral": {
    "_light": "neutral.300",
    "_dark": "neutral.700"
  },
  "border-info": {
    "_light": "info.300",
    "_dark": "info.700"
  },
  "border-success": {
    "_light": "success.300",
    "_dark": "success.700"
  },
  "border-warning": {
    "_light": "warning.300",
    "_dark": "warning.700"
  },
  "border-error": {
    "_light": "error.300",
    "_dark": "error.700"
  },
  "border-highlight": {
    "_light": "highlight.300",
    "_dark": "highlight.700"
  },
  "surface-page": {
    "_light": "white",
    "_dark": "neutral.950"
  },
  "surface-inset": {
    "_light": "neutral.25",
    "_dark": "black"
  },
  "surface-hover": {
    "_light": "grayAlpha.50",
    "_dark": "whiteAlpha.50"
  },
  "surface-active": {
    "_light": "grayAlpha.100",
    "_dark": "whiteAlpha.100"
  },
  "surface-invert": {
    "_light": "neutral.900",
    "_dark": "neutral.100"
  },
  "text-emphasis": {
    "_light": "neutral.900",
    "_dark": "white"
  },
  "text-emphasis-invert": {
    "_light": "white",
    "_dark": "neutral.900"
  },
  "text-muted": {
    "_light": "neutral.600",
    "_dark": "whiteAlpha.600"
  },
  "text-muted-invert": {
    "_light": "whiteAlpha.600",
    "_dark": "neutral.600"
  },
  "text-subdued": {
    "_light": "neutral.500",
    "_dark": "whiteAlpha.500"
  },
  "text-subdued-invert": {
    "_light": "whiteAlpha.500",
    "_dark": "neutral.500"
  },
  "text-placeholder": {
    "_light": "neutral.400",
    "_dark": "whiteAlpha.400"
  },
  "text-brand": {
    "_light": "brand.600",
    "_dark": "brand.300"
  },
  "text-brand-hover": {
    "_light": "brand.700",
    "_dark": "brand.200"
  },
  "text-brand-active": {
    "_light": "brand.800",
    "_dark": "brand.100"
  },
  "text-brand-invert": {
    "_light": "brand.300",
    "_dark": "brand.500"
  },
  "text-brand-invert-hover": {
    "_light": "brand.200",
    "_dark": "brand.600"
  },
  "text-brand-invert-active": {
    "_light": "brand.100",
    "_dark": "brand.700"
  },
  "text-interactive": {
    "_light": "brand.600",
    "_dark": "brand.300"
  },
  "text-interactive-hover": {
    "_light": "brand.700",
    "_dark": "brand.200"
  },
  "text-interactive-active": {
    "_light": "brand.800",
    "_dark": "brand.100"
  },
  "text-interactive-invert": {
    "_light": "brand.300",
    "_dark": "brand.500"
  },
  "text-interactive-invert-hover": {
    "_light": "brand.200",
    "_dark": "brand.600"
  },
  "text-interactive-invert-active": {
    "_light": "brand.100",
    "_dark": "brand.700"
  },
  "text-error": {
    "_light": "error.600",
    "_dark": "error.300"
  },
  "text-error-hover": {
    "_light": "error.600",
    "_dark": "error.200"
  },
  "text-error-invert": {
    "_light": "error.300",
    "_dark": "error.500"
  },
  "text-info": {
    "_light": "info.600",
    "_dark": "info.300"
  },
  "text-info-hover": {
    "_light": "info.600",
    "_dark": "info.200"
  },
  "text-info-invert": {
    "_light": "info.300",
    "_dark": "info.600"
  },
  "text-warning": {
    "_light": "warning.600",
    "_dark": "warning.300"
  },
  "text-warning-hover": {
    "_light": "warning.600",
    "_dark": "warning.400"
  },
  "text-warning-invert": {
    "_light": "warning.300",
    "_dark": "warning.500"
  },
  "text-success": {
    "_light": "success.600",
    "_dark": "success.300"
  },
  "text-success-hover": {
    "_light": "success.700",
    "_dark": "success.400"
  },
  "text-success-invert": {
    "_light": "success.300",
    "_dark": "success.600"
  },
  "surface-success": {
    "_light": "success.500",
    "_dark": "success.600"
  },
  "surface-success-subdued": {
    "_light": "success.25",
    "_dark": "success.900"
  },
  "surface-warning": {
    "_light": "warning.500",
    "_dark": "warning.600"
  },
  "surface-warning-subdued": {
    "_light": "warning.25",
    "_dark": "warning.900"
  },
  "surface-error": {
    "_light": "error.500",
    "_dark": "error.600"
  },
  "surface-error-subdued": {
    "_light": "error.25",
    "_dark": "error.900"
  },
  "surface-info": {
    "_light": "info.500",
    "_dark": "info.600"
  },
  "surface-info-subdued": {
    "_light": "info.25",
    "_dark": "info.900"
  },
  "surface-neutral": {
    "_light": "neutral.500",
    "_dark": "neutral.600"
  },
  "surface-neutral-accent": {
    "_light": "neutral.200",
    "_dark": "neutral.700"
  },
  "surface-neutral-muted": {
    "_light": "neutral.100",
    "_dark": "neutral.800"
  },
  "surface-neutral-subdued": {
    "_light": "neutral.50",
    "_dark": "neutral.900"
  },
  "surface-brand": {
    "_light": "brand.500",
    "_dark": "brand.600"
  },
  "surface-brand-accent": {
    "_light": "brand.200",
    "_dark": "brand.800"
  },
  "surface-brand-muted": {
    "_light": "brand.100",
    "_dark": "brand.900"
  },
  "surface-brand-subdued": {
    "_light": "brand.25",
    "_dark": "brand.950"
  },
  "text-on-brand": {
    "_light": "white",
    "_dark": "white"
  },
  "surface-highlight": {
    "_light": "highlight.500",
    "_dark": "highlight.600"
  },
  "surface-highlight-accent": {
    "_light": "highlight.200",
    "_dark": "highlight.700"
  },
  "surface-highlight-muted": {
    "_light": "highlight.100",
    "_dark": "highlight.800"
  },
  "surface-highlight-subdued": {
    "_light": "highlight.50",
    "_dark": "highlight.900"
  },
  "text-on-highlight": {
    "_light": "white",
    "_dark": "white"
  },
  "text-highlight": {
    "_light": "highlight.600",
    "_dark": "highlight.300"
  },
  "text-highlight-emphasis": {
    "_light": "highlight.800",
    "_dark": "highlight.100"
  },
  "text-on-success": {
    "_light": "white",
    "_dark": "white"
  },
  "text-on-warning": {
    "_dark": "white",
    "_light": "white"
  },
  "text-on-info": {
    "_dark": "white",
    "_light": "white"
  },
  "surface-disabled": {
    "_light": "grayAlpha.75",
    "_dark": "whiteAlpha.75"
  },
  "surface-selected": {
    "_light": "brand.25",
    "_dark": "brand.800"
  },
  "text-disabled": {
    "_light": "grayAlpha.400",
    "_dark": "whiteAlpha.400"
  },
  "surface-primary": {
    "_light": "brand.500",
    "_dark": "brand.700"
  },
  "surface-primary-hover": {
    "_light": "brand.600",
    "_dark": "brand.600"
  },
  "surface-primary-active": {
    "_light": "brand.700",
    "_dark": "brand.500"
  },
  "surface-secondary": {
    "_light": "white",
    "_dark": "brand.975"
  },
  "surface-secondary-hover": {
    "_light": "brand.25",
    "_dark": "brand.950"
  },
  "surface-secondary-active": {
    "_light": "brand.50",
    "_dark": "brand.900"
  },
  "surface-tertiary": {
    "_light": "grayAlpha.50",
    "_dark": "whiteAlpha.50"
  },
  "surface-tertiary-hover": {
    "_light": "grayAlpha.75",
    "_dark": "whiteAlpha.75"
  },
  "surface-tertiary-active": {
    "_light": "grayAlpha.100",
    "_dark": "whiteAlpha.100"
  },
  "surface-tertiary-invert": {
    "_light": "whiteAlpha.50",
    "_dark": "blackAlpha.50"
  },
  "surface-tertiary-invert-hover": {
    "_light": "whiteAlpha.100",
    "_dark": "blackAlpha.100"
  },
  "surface-tertiary-invert-active": {
    "_light": "whiteAlpha.200",
    "_dark": "blackAlpha.200"
  },
  "surface-elevated": {
    "_light": "white",
    "_dark": "neutral.900"
  },
  "surface-elevated-hover": {
    "_light": "neutral.50",
    "_dark": "neutral.800"
  },
  "surface-elevated-active": {
    "_light": "neutral.75",
    "_dark": "neutral.700"
  },
  "surface-elevated-invert": {
    "_light": "neutral.700",
    "_dark": "neutral.100"
  },
  "surface-dialog": {
    "_light": "white",
    "_dark": "neutral.700"
  },
  "surface-dialog-hover": {
    "_light": "neutral.25",
    "_dark": "neutral.600"
  },
  "surface-dialog-active": {
    "_light": "neutral.50",
    "_dark": "neutral.500"
  },
  "text-on-primary": {
    "_light": "white",
    "_dark": "white"
  },
  "text-on-primary-hover": {
    "_light": "white",
    "_dark": "white"
  },
  "text-on-primary-active": {
    "_light": "white",
    "_dark": "white"
  },
  "text-on-secondary": {
    "_light": "brand.600",
    "_dark": "brand.300"
  },
  "text-on-secondary-hover": {
    "_light": "brand.700",
    "_dark": "brand.200"
  },
  "text-on-secondary-active": {
    "_light": "brand.800",
    "_dark": "brand.100"
  },
  "surface-warning-accent": {
    "_light": "warning.200",
    "_dark": "warning.700"
  },
  "surface-warning-muted": {
    "_light": "warning.100",
    "_dark": "warning.800"
  },
  "surface-error-accent": {
    "_light": "error.200",
    "_dark": "error.700"
  },
  "surface-error-muted": {
    "_light": "error.100",
    "_dark": "error.800"
  },
  "surface-info-accent": {
    "_light": "info.200",
    "_dark": "info.700"
  },
  "surface-info-muted": {
    "_light": "info.100",
    "_dark": "info.800"
  },
  "surface-success-accent": {
    "_light": "success.200",
    "_dark": "success.700"
  },
  "surface-success-muted": {
    "_light": "success.100",
    "_dark": "success.800"
  },
  "text-on-error": {
    "_light": "white",
    "_dark": "white"
  },
  "icon-default": {
    "_light": "grayAlpha.400",
    "_dark": "whiteAlpha.400"
  },
  "icon-hover": {
    "_light": "grayAlpha.500",
    "_dark": "whiteAlpha.500"
  },
  "icon-active": {
    "_light": "grayAlpha.600",
    "_dark": "whiteAlpha.600"
  },
  "icon-neutral": {
    "_light": "neutral.400",
    "_dark": "neutral.300"
  },
  "icon-brand": {
    "_light": "brand.400",
    "_dark": "brand.300"
  },
  "icon-brand-selected": {
    "_light": "brand.500",
    "_dark": "brand.200"
  },
  "icon-success": {
    "_light": "success.400",
    "_dark": "success.300"
  },
  "icon-error": {
    "_light": "error.400",
    "_dark": "error.300"
  },
  "icon-info": {
    "_light": "info.400",
    "_dark": "info.300"
  },
  "icon-highlight": {
    "_light": "highlight.400",
    "_dark": "highlight.300"
  },
  "icon-warning": {
    "_light": "warning.400",
    "_dark": "warning.300"
  },
  "neutral": {
    "25": "gray.25",
    "50": "gray.50",
    "75": "gray.75",
    "100": "gray.100",
    "200": "gray.200",
    "300": "gray.300",
    "400": "gray.400",
    "500": "gray.500",
    "600": "gray.600",
    "700": "gray.700",
    "800": "gray.800",
    "900": "gray.900",
    "950": "gray.950",
    "975": "gray.975"
  },
  "error": {
    "25": "red.25",
    "50": "red.50",
    "100": "red.100",
    "200": "red.200",
    "300": "red.300",
    "400": "red.400",
    "500": "red.500",
    "600": "red.600",
    "700": "red.700",
    "800": "red.800",
    "900": "red.900",
    "950": "red.950",
    "975": "red.975"
  },
  "warning": {
    "25": "yellow.25",
    "50": "yellow.50",
    "100": "yellow.100",
    "200": "yellow.200",
    "300": "yellow.300",
    "400": "yellow.400",
    "500": "yellow.500",
    "600": "yellow.600",
    "700": "yellow.700",
    "800": "yellow.800",
    "900": "yellow.900",
    "950": "yellow.950",
    "975": "yellow.975"
  },
  "success": {
    "25": "lime.25",
    "50": "lime.50",
    "100": "lime.100",
    "200": "lime.200",
    "300": "lime.300",
    "400": "lime.400",
    "500": "lime.500",
    "600": "lime.600",
    "700": "lime.700",
    "800": "lime.800",
    "900": "lime.900",
    "950": "lime.950",
    "975": "lime.975"
  },
  "brand": {
    "25": "indigo.25",
    "50": "indigo.50",
    "100": "indigo.100",
    "200": "indigo.200",
    "300": "indigo.300",
    "400": "indigo.400",
    "500": "indigo.500",
    "600": "indigo.600",
    "700": "indigo.700",
    "800": "indigo.800",
    "900": "indigo.900",
    "950": "indigo.950",
    "975": "indigo.975"
  },
  "info": {
    "25": "cyan.25",
    "50": "cyan.50",
    "100": "cyan.100",
    "200": "cyan.200",
    "300": "cyan.300",
    "400": "cyan.400",
    "500": "cyan.500",
    "600": "cyan.600",
    "700": "cyan.700",
    "800": "cyan.800",
    "900": "cyan.900",
    "950": "cyan.950",
    "975": "cyan.975"
  },
  "highlight": {
    "25": "purple.25",
    "50": "purple.50",
    "100": "purple.100",
    "200": "purple.200",
    "300": "purple.300",
    "400": "purple.400",
    "500": "purple.500",
    "600": "purple.600",
    "700": "purple.700",
    "800": "purple.800",
    "900": "purple.900",
    "950": "purple.950",
    "975": "purple.975"
  }
};
export const shadows = {
  "elevations": {
    "0": "none",
    "1": "xs",
    "2": "sm",
    "3": "md",
    "4": "lg",
    "5": "xl"
  }
};
export const space = {
  "base": {
    "2xs": "1",
    "xs": "2",
    "sm": "3",
    "md": "5",
    "lg": "8",
    "xl": "12",
    "2xl": "16"
  },
  "dense": {
    "2xs": "1",
    "xs": "1_5",
    "sm": "2",
    "md": "4",
    "lg": "6",
    "xl": "8",
    "2xl": "12"
  },
  "spacious": {
    "2xs": "1",
    "xs": "2",
    "sm": "4",
    "md": "6",
    "lg": "10",
    "xl": "16",
    "2xl": "20"
  }
};
export const fontWeights = {
  "h1": "extrabold",
  "h2": "bold",
  "h3": "bold",
  "h4": "bold",
  "h5": "bold",
  "h6": "bold",
  "divider": "extrabold",
  "ui": "semibold",
  "body": "regular",
  "link": "medium"
};
export const fontSizes = {
  "base": {
    "h1": "3xl",
    "h2": "2xl",
    "h3": "xl",
    "h4": "lg",
    "h5": "md",
    "h6": "sm",
    "ui-divider": "3xs",
    "ui-compact": "xs",
    "ui-default": "sm",
    "p1": "md",
    "p2": "sm",
    "p3": "xs",
    "p4": "2xs"
  }
};
export const textStyles = {
  "base": {
    "ui-micro": {
      "fontSize": "3xs",
      "lineHeight": "5",
      "fontFamily": "heading",
      "fontWeight": "semibold"
    },
    "ui-compact": {
      "fontSize": "xs",
      "lineHeight": "4",
      "fontFamily": "heading",
      "fontWeight": "semibold"
    },
    "ui-default": {
      "fontSize": "sm",
      "fontFamily": "heading",
      "fontWeight": "semibold",
      "lineHeight": "5"
    },
    "divider": {
      "fontSize": "xs",
      "lineHeight": "base",
      "fontFamily": "heading",
      "textTransform": "uppercase",
      "letterSpacing": "wider",
      "fontWeight": "semibold"
    },
    "p4": {
      "fontSize": "2xs",
      "fontFamily": "body",
      "lineHeight": "3-5",
      "fontWeight": "regular"
    },
    "p3": {
      "fontFamily": "body",
      "fontWeight": "regular",
      "fontSize": "xs",
      "lineHeight": "4"
    },
    "p2": {
      "fontFamily": "body",
      "fontWeight": "regular",
      "fontSize": "sm",
      "lineHeight": "5"
    },
    "p1": {
      "fontFamily": "body",
      "fontWeight": "regular",
      "fontSize": "md",
      "lineHeight": "6"
    },
    "subtitle": {
      "fontFamily": "body",
      "fontWeight": "regular",
      "fontSize": "lg",
      "lineHeight": "6"
    },
    "h6": {
      "fontFamily": "heading",
      "fontWeight": "bold",
      "fontSize": "xs",
      "lineHeight": "4"
    },
    "h5": {
      "fontFamily": "heading",
      "fontWeight": "bold",
      "fontSize": "sm",
      "lineHeight": "4-5"
    },
    "h4": {
      "fontFamily": "heading",
      "fontWeight": "bold",
      "fontSize": "md",
      "lineHeight": "5"
    },
    "h3": {
      "fontFamily": "heading",
      "fontWeight": "bold",
      "fontSize": "lg",
      "lineHeight": "5-5"
    },
    "h2": {
      "fontFamily": "heading",
      "fontWeight": "bold",
      "fontSize": "xl",
      "lineHeight": "6"
    },
    "h1": {
      "fontFamily": "heading",
      "fontWeight": "extrabold",
      "fontSize": "2xl",
      "lineHeight": "6-5"
    },
    "h0": {
      "fontFamily": "heading",
      "fontWeight": "bold",
      "fontSize": "4xl",
      "lineHeight": "9"
    }
  },
  "dense": {
    "h0": {
      "fontFamily": "heading",
      "fontWeight": "bold",
      "lineHeight": "9",
      "fontSize": "4xl"
    },
    "h1": {
      "fontFamily": "heading",
      "fontWeight": "extrabold",
      "lineHeight": "6-5",
      "fontSize": "2xl"
    },
    "h2": {
      "fontFamily": "heading",
      "fontWeight": "bold",
      "lineHeight": "5-5",
      "fontSize": "lg"
    },
    "h3": {
      "fontFamily": "heading",
      "fontWeight": "bold",
      "lineHeight": "5",
      "fontSize": "md"
    },
    "h4": {
      "fontFamily": "heading",
      "fontWeight": "bold",
      "lineHeight": "4-5",
      "fontSize": "xs"
    },
    "h5": {
      "fontFamily": "heading",
      "fontWeight": "bold",
      "lineHeight": "4",
      "fontSize": "sm"
    },
    "h6": {
      "fontFamily": "heading",
      "fontWeight": "bold",
      "lineHeight": "3-5",
      "fontSize": "2xs"
    },
    "subtitle": {
      "fontFamily": "body",
      "fontWeight": "regular",
      "lineHeight": "5",
      "fontSize": "md"
    },
    "ui-default": {
      "fontFamily": "body",
      "fontWeight": "semibold",
      "lineHeight": "4",
      "fontSize": "xs"
    },
    "divider": {
      "fontFamily": "heading",
      "fontWeight": "semibold",
      "lineHeight": "base",
      "fontSize": "2xs"
    },
    "ui-compact": {
      "fontFamily": "body",
      "fontWeight": "semibold",
      "lineHeight": "3",
      "fontSize": "2xs"
    },
    "ui-micro": {
      "fontFamily": "body",
      "fontWeight": "semibold",
      "lineHeight": "base",
      "fontSize": "3xs"
    },
    "p1": {
      "fontFamily": "body",
      "fontWeight": "regular",
      "lineHeight": "5",
      "fontSize": "sm"
    },
    "p2": {
      "fontFamily": "body",
      "fontWeight": "regular",
      "lineHeight": "4",
      "fontSize": "xs"
    },
    "p3": {
      "fontFamily": "body",
      "fontWeight": "regular",
      "lineHeight": "3-5",
      "fontSize": "2xs"
    },
    "p4": {
      "fontFamily": "body",
      "fontWeight": "regular",
      "lineHeight": "3",
      "fontSize": "3xs"
    }
  },
  "spacious": {
    "h0": {
      "fontFamily": "heading",
      "fontWeight": "bold",
      "lineHeight": "11",
      "fontSize": "6xl"
    },
    "h1": {
      "fontFamily": "heading",
      "fontWeight": "extrabold",
      "lineHeight": "9",
      "fontSize": "4xl"
    },
    "h2": {
      "fontFamily": "heading",
      "fontWeight": "bold",
      "lineHeight": "7",
      "fontSize": "3xl"
    },
    "h3": {
      "fontFamily": "heading",
      "fontWeight": "bold",
      "lineHeight": "6",
      "fontSize": "2xl"
    },
    "h4": {
      "fontFamily": "heading",
      "fontWeight": "bold",
      "lineHeight": "5",
      "fontSize": "xl"
    },
    "h5": {
      "fontFamily": "heading",
      "fontWeight": "bold",
      "lineHeight": "4",
      "fontSize": "lg"
    },
    "h6": {
      "fontFamily": "heading",
      "fontWeight": "bold",
      "lineHeight": "4-5",
      "fontSize": "md"
    },
    "subtitle": {
      "fontFamily": "body",
      "fontWeight": "regular",
      "lineHeight": "6",
      "fontSize": "2xl"
    },
    "ui-default": {
      "fontFamily": "body",
      "fontWeight": "semibold",
      "lineHeight": "5",
      "fontSize": "md"
    },
    "divider": {
      "fontFamily": "heading",
      "fontWeight": "semibold",
      "lineHeight": "base",
      "fontSize": "xs"
    },
    "ui-compact": {
      "fontFamily": "body",
      "fontWeight": "semibold",
      "lineHeight": "4",
      "fontSize": "xs"
    },
    "ui-micro": {
      "fontFamily": "body",
      "fontWeight": "semibold",
      "lineHeight": "base",
      "fontSize": "3xs"
    },
    "p1": {
      "fontFamily": "body",
      "fontWeight": "regular",
      "lineHeight": "7",
      "fontSize": "lg"
    },
    "p2": {
      "fontFamily": "body",
      "fontWeight": "regular",
      "lineHeight": "6",
      "fontSize": "md"
    },
    "p3": {
      "fontFamily": "body",
      "fontWeight": "regular",
      "lineHeight": "5",
      "fontSize": "sm"
    },
    "p4": {
      "fontFamily": "body",
      "fontWeight": "regular",
      "lineHeight": "4",
      "fontSize": "xs"
    }
  }
};